<template>
  <v-dialog
    :value="show"
    fullscreen
    hide-overlay
    persistent
    class="toolbar"
    transition="dialog-bottom-transition"
  >
    <v-card :id="id">
      <v-toolbar>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            class="btn"
            icon
            @click="close"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            md="6"
            offset-md="3"
            lg="4"
            offset-lg="4"
          >
            <screen
              v-if="useDefaultScreen || useAmount"
              class="mt-2 mx-2"
              in-modal
              :use-amount="useAmount"
              :title="screenTitle"
              :info="display"
            />
            <screen
              v-else-if="useSoldeScreen"
              class="mt-2 mx-2"
              in-modal
              :title="$t('words.solde')"
              :info="$amount(solde)"
              infoclass="green--text"
              :titlesup="$t('title.amount_transfer')"
              :infosup="$amount(value)"
            />
            <slot v-else />
          </v-col>
        </v-row>
      </v-container>

      <keyboard-code
        v-if="keyboardCode"
        v-model="value"
        :use-listener="useListener"
        @del="close"
        @cancel="close"
        @valid="valid"
      />
      <keyboard
        v-else
        v-model="value"
        :use-listener="useListener"
        :max="max"
        @del="close"
        @cancel="close"
        @valid="valid"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { $amount } from '@/modules/Utils'

export default {
  name: 'KeyboardDialog',

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    show: { type: Boolean, default: false },
    id: { type: String, default: 'keyboard-dialog' },
    useDefaultScreen: { type: Boolean, default: false },
    useSoldeScreen: { type: Boolean, default: false },
    useAmount: { type: Boolean, default: false },
    max: { type: Number, default: null },
    solde: { type: Number, default: 0 },
    title: { type: String, default: 'Saisie du montant' },
    screenTitle: { type: String, default: 'Montant' },
    keyboardCode: { type: Boolean, default: false },
    secureCode: { type: Boolean, default: false },
    autoClose: { type: Boolean, default: false },
    useListener: { type: Boolean, default: true }
  },

  data () {
    return {
      value: this.keyboardCode ? '' : 0
    }
  },

  computed: {
    display () {
      return !this.keyboardCode ? $amount(this.value)
        : this.secureCode ? this.secureDisplay
          : this.value
    },
    secureDisplay () {
      return ''.padStart(this.value.length, '*')
    }
  },

  methods: {
    $amount,
    reset () {
      this.value = this.keyboardCode ? '' : 0
    },
    close () {
      if (this.autoClose) this.$emit('change', false)
      this.$emit('close')
      setTimeout(() => {
        this.reset()
      }, 200)
    },
    valid () {
      if (this.value > 0) {
        if (this.autoClose) this.$emit('change', false)
        this.$emit('valid', this.value)
        setTimeout(() => {
          this.reset()
        }, 200)
      }
    }
  }
}
</script>
